import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=6b30dd82"
import script from "./addService.vue?vue&type=script&lang=js"
export * from "./addService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports